import { IS_PRODUCTION } from '@utils/constants'

import * as S from './DevEnvBadge.styles'

export const DevEnvBadge = () => {
  return IS_PRODUCTION ? null : <S.Label>DEV VERSION</S.Label>
}
